import React from 'react';

export const CompanyInfoShadow = ({ className }) => {
  return (
    <div className={`pa-acc-info__text pa-acc-info__shadow ${className}`} />
  );
};
